import { Loader2 } from 'lucide-react';
import styles from './Spinner.module.scss';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const PIXEL_SIZE = { sm: 16, md: 24, lg: 40 } as const;

export function Spinner({ size = 'md', label = 'Cargando' }: SpinnerProps) {
  return (
    <span className={`${styles.spinner} ${styles[`size-${size}`]}`} role="status" aria-label={label}>
      <Loader2 size={PIXEL_SIZE[size]} strokeWidth={2.5} />
    </span>
  );
}
